<ng-container *appI18nScopeReady>
  <h2 mat-dialog-title>{{ 'title' | i18n }}</h2>

  <mat-dialog-content>
    <div class="form">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'name_label' | i18n }}</mat-label>
        <input
          matInput
          [(ngModel)]="name"
          [placeholder]="'name_placeholder' | i18n"
          (keydown.enter)="apply()"
        />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{ 'description_label' | i18n }}</mat-label>
        <textarea
          matInput
          [(ngModel)]="description"
          [placeholder]="'description_placeholder' | i18n"
          rows="3"
        ></textarea>
      </mat-form-field>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button type="button" mat-button (click)="cancel()">
      {{ 'cancel' | i18n }}
    </button>
    <button
      type="button"
      mat-flat-button
      color="primary"
      [disabled]="!isValid"
      (click)="apply()"
    >
      {{ 'create' | i18n }}
    </button>
  </mat-dialog-actions>
</ng-container>
